export default function Url(props) {
	return (
		<a id="a11y-url" href={props.link}>
			<strong>{props.children}</strong>
		</a>
	);
}
